import { useEffect } from 'react';

import { useCommandPaletteStore } from '../store';

/** Global ⌘K / Ctrl+K listener toggling the palette. */
export function useCommandPaletteShortcut() {
  const toggle = useCommandPaletteStore(({ toggle }) => toggle);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && !event.altKey && !event.shiftKey && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        toggle();
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [toggle]);
}
